module.exports = __webpack_public_path__ + "static/media/needle-loader-white.2e462866.gif";